module.exports = __webpack_public_path__ + "static/media/katie_chung.6b50368c.png";